export default __webpack_public_path__ + "static/media/pic4.6ff02077.jpg";